/**
* Web Service handler to send updated consumer custom properties to the service
*
* @class UpdateCustomPropsWS
*/
function UpdateCustomPropsWS (parent) {
	var self = this;

	AbstractWS.apply(this, arguments);

	self.locationId	= ko.observable( null );
	self.method		= ko.observable( 'POST' );
	self.name		= 'UpdateCustomPropsWS';


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL	= ko.computed( function () {
		return '/qless/api/v1/kiosk/location/' + self.locationId() + '/customProps';
	});


	/**
	* Returns the object to it's default state
	*
	* @method reset
	* @return none
	*/
	self.reset = function () {
		self.locationId( null );
		self.clearParams();
	};

	return self;
};

UpdateCustomPropsWS.prototype = AbstractWS.prototype;
UpdateCustomPropsWS.prototype.constructor = UpdateCustomPropsWS;
